import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import CashierConfig from './cashier-config/cashier-config'
import ShopInfo from './shop-info/shop-info'
import TicketPrinting from './ticket-printing/ticket-printing'

const path = '/main/setting'

export const SETTING_SHOP_INFO = path + '/shopInfo'
export const SETTING_CASHIER_CONFIG = path + '/cashier'
export const SETTING_TICKET_PRINTING = path + '/cashier/ticket'

export default (props: RouteComponentProps) => (
    <Switch>
        <Route path={props.match.path + '/shopInfo'} component={ShopInfo} />
        <Route path={props.match.path + '/cashier/ticket'} component={TicketPrinting} />
        <Redirect exact from={props.match.path + '/ticket'} to={SETTING_TICKET_PRINTING} />
        <Route path={props.match.path + '/cashier'} component={CashierConfig} />
        <Redirect to={SETTING_SHOP_INFO} />
    </Switch>
)
